import { pick } from 'ramda';

export default pick(['label', 'disabled']);
